export default __webpack_public_path__ + "static/media/exterior7.6aa1e35f.jpeg";